import { Text } from "@src/appV2/redesign/system/ui-components";

import { ScreeningSurveyInfoLayout } from "./components/ScreeningSurveyInfoLayout";

interface ScreeningSurveyPassedProps {
  onNext: () => void;
}

export function ScreeningSurveyPassed(props: ScreeningSurveyPassedProps) {
  const { onNext } = props;

  return (
    <ScreeningSurveyInfoLayout
      title="One More Step"
      icon="checkmark-illustration"
      action={{ label: "Next", onClick: onNext }}
    >
      <Text
        variant="h4"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        Professionals are required to sign a Business Associate Agreement (BAA) that governs
        handling patient information.
      </Text>
      <Text
        variant="h4"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        After you sign, you&apos;re all set!
      </Text>
    </ScreeningSurveyInfoLayout>
  );
}
